export const endPoint = 'http://161.35.104.253:8000'
